import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=2db1a030&scoped=true"
import script from "./TitleBar.vue?vue&type=script&lang=js"
export * from "./TitleBar.vue?vue&type=script&lang=js"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=2db1a030&prod&scoped=true&lang=css"
import style1 from "./TitleBar.vue?vue&type=style&index=1&id=2db1a030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1a030",
  null
  
)

export default component.exports